module.exports = "images/doc-activity-add-3.5945ba2bda4c82d7c20eebfb57280317.png";